import React from 'react'

import { PersonalizedProductRecoCarousel } from '@pb/components'

import style from './RecentlyViewed.scss'

const RecentlyViewed: React.FC = () => {
  return (
    <>
      <PersonalizedProductRecoCarousel
        className={style.carouselContainer}
        imagetype="stilllife"
        disablecarousel={false}
        pratype="PRA15"
      />
    </>
  )
}

export default RecentlyViewed
